import apiInstance from "./axios";
import { login } from "utils/services/api/schemas";

const authApi = {
  login: async (payload) => {
    const response = await apiInstance.post(login, payload);
    return response;
  },
};

export default authApi;
